export default __webpack_public_path__ + "static/media/empty-due-tasks.ad32c979.svg";